import transport from "core/model/api/transport";
import { SessionKey } from "core/types";

export default {
  getRequestCounts(careproviderId?: number): Promise<any> {
    return transport.get({
      route: `/careproviders/requestscount/${careproviderId}`,
    });
  },
  getRequestEvents(requestId: number): Promise<any> {
    return transport.get({
      route: `/events?reverse&auction_request_id=${requestId}`,
    });
  },
  updateSessionKeys(
    requestId: number,
    sessionKeys: Array<SessionKey>,
  ): Promise<any> {
    return transport.put({
      body: sessionKeys,
      route: `/crypto/sessions/${requestId}`,
    });
  },
};
